<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>

<template>
    <div>
    <ContainerCards/>
  </div>
</template>

<script>
import ContainerCards from "@/components/scenarios/iiot/ContainerCards.vue";
  export default {
    name: "ThingDescriptions",
    components: { 
      ContainerCards
     },
  }
</script>